let filtreNombreJours = {
    props: {
        njmin: Number,
        njmax: Number,
    },
    directives: {
        clickaway
    },
    data() {
        return {
            isDropdownActive: false,
        }
    },
    methods: {
        clickGroupeFiltres() {
            this.isDropdownActive = !this.isDropdownActive;
            // console.log('label:'+this.isDropdownActive)
        },
        clickChildrenLabel() {
            this.isDropdownActive = false;
            // console.log('away:'+this.isDropdownActive)
        },
        nombrejoursevent() {
            this.$root.callfilters(event)
            this.isDropdownActive = false
        },
    },
    // methods: {
    //     filtrevent () {
    //         this.$emit('filtrevent')
    //     }
    // },
    template: `
    <div class="profile filter-block" :class="{ 'is-active': isDropdownActive }" v-clickaway="clickChildrenLabel">
        <h4 @click="clickGroupeFiltres" :class="(njmin != 0 || njmax != 1000) ? 'selected' : ''">Durée du séjour</h4>
        <div class="filter-content filter-nombreJours filters list">
            <ul>
                <li :class="(njmin == '0' && njmax == '1000') ? 'selected filter' : 'filter'">
                    <span @click="nombrejoursevent" class="nombrejoursevent filter-rbl label" data-njmin="0" data-njmax="1000">Toutes les durées</span>
                </li>
                <li :class="(njmin == '0' && njmax == '2') ? 'selected filter' : 'filter'">
                    <span @click="nombrejoursevent" class="nombrejoursevent filter-rbl label" data-njmin="0" data-njmax="2">Moins de 2 jours</span>
                </li>
                <li :class="(njmin == '3' && njmax == '3') ? 'selected filter' : 'filter'">
                    <span @click="nombrejoursevent" class="nombrejoursevent filter-rbl label" data-njmin="3" data-njmax="3">3 jours / 2 nuits</span>
                </li>
                <li :class="(njmin == '3' && njmax == '1000') ? 'selected filter' : 'filter'">
                    <span @click="nombrejoursevent" class="nombrejoursevent filter-rbl label" data-njmin="3" data-njmax="1000">Supérieur à 3 jours</span>
                </li>
            </ul>
            <div class="input-number">
                <input type="hidden" name="njmin" id="min-number-nombreJours" class="min-number autosize" v-model="njmin">
                <input type="hidden" name="njmax" id="max-number-nombreJours" class="max-number autosize" v-model="njmax">
            </div>
        </div>
    </div>
    `
};